import { Injectable } from '@angular/core';
import { GlobalService } from '@commoncore/services/global.service';
import { UniversalService } from '@commoncore/services/universal.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PeopleService {

  static singleInstance: any = null;
  private peopleData = new BehaviorSubject<any>(null);
  peopleData$ = this.peopleData.asObservable();
  private selectedPeopleId: any | null = null;
  private nextLinkData: any | null = null;
  private scrollPosition: number = 0;  
  private isResetRequired:boolean = false;

  constructor(public universalService: UniversalService){
  }  

  public static getInstance(globalService): PeopleService {
    if (this.singleInstance == null) {
      this.singleInstance = new PeopleService(globalService);
      return this.singleInstance;
    } else {
      return this.singleInstance;
    }
  }

  setPeopleData(data: any) {
    this.peopleData.next(data);
  }

  setSelectedPeople(id: any): void {
    this.selectedPeopleId = id;
  }

  getSelectedPeople(): any | null {
    return this.selectedPeopleId;
  }
  setScrollPosition(position: number): void {
    this.scrollPosition = position;
  }

  getScrollPosition(): number {
    return this.scrollPosition;
  }

  setNextLinkData(link: any): void {
    this.nextLinkData = link;
  }

  getNextLinkData(): any | null {
    return this.nextLinkData;
  }

  setIsResetRequired(val: boolean): void {
    this.isResetRequired = val;
  }

  getIsResetRequired(): boolean | null {
    return this.isResetRequired;
  }

}
